export default __webpack_public_path__ + "static/media/apostar_icons_meineapotheke.f943f5e3.svg";